import PreventDoubleSubmitBehaviour from "../behaviours/prevent-form-double-submission-behaviour";

require('../../scss/app-default.scss');

import DeckPlanBehaviour from "../behaviours/deck-plan-behaviour";
import PartialBehaviour from '../behaviours/partial-behaviour';
import UrlParameterHandlerBehaviour from '../behaviours/url-parameter-handler-behaviour';
import ScrollToBehaviour from '../behaviours/scroll-to-behaviour';
import TabsBehaviour from "../behaviours/tabs-behaviour";
import HideShowBehaviour from "../behaviours/hide-show-behaviour";
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import ChoiceOtherBehaviour from "../behaviours/choice-other-behaviour";
import CarouselBehaviour from "../behaviours/carousel-behaviour";
import StickyNavBehaviour from "../behaviours/sticky-nav-behaviour";


import YoutubeVideo from "../jsx/video/youtube-video";
import CountDown from "../jsx/count-down";
import Gallery from "../jsx/gallery";
import SoloToggle from "../jsx/solo-toggle";
import SearchTemplateFull from "../jsx/search/template-full";
import SearchTemplateResults from "../jsx/search/template-results";
import AddressLookup from "../jsx/address-lookup/address-lookup";
import BackgroundImageBehaviour from '../behaviours/background-image-behaviour';
import ShortlistCount from '../jsx/shortlist/shortlist-count';
import ShortlistButton from '../jsx/shortlist/shortlist-button';
import ShortlistShow from '../jsx/shortlist/shortlist-show';
import ShortlistClear from "../jsx/shortlist/shortlist-clear";
import ShortlistFieldBehavior from "../behaviours/shortlist-field-behaviour";
import PlaceHolderSetterBehaviour from "../behaviours/form-field-changer-behaviour";
import EmbeddedGallery from '../jsx/embedded-gallery';
import AccordionBehaviour from "../behaviours/accordion-behaviour";
import LocalstorageFieldPopulationBehaviour from "../behaviours/localstorage-field-population-behaviour";
import ReadMoreBehaviour from "../behaviours/read-more-behaviour";
import MyRolTabsBehaviour from "../behaviours/myrol-tabs-behaviour";
import TogglePasswordBehavior from "../behaviours/toggle-password-field";
import PreferencesUpdateBehaviour from "../behaviours/preferences-update-behaviour";
import CruiseDriver from "../jsx/search/cruise-driver";
import CountdownBehavior from "../behaviours/countdown-timer-behaviour";
import DatalayerBehaviour from "../behaviours/datalayer-behaviour";
import Application from "./application";
import SelectLinkBehaviour from "../behaviours/select-link-behaviour";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";
import HashBehaviour from "../behaviours/hash-behaviour";
import AcousticSignalBehaviour from "../behaviours/acoustic-signal-behaviour";



let config = {};
config.behaviours = {
        'PartialBehaviour': new PartialBehaviour(),
        'UrlParameterHandle': new UrlParameterHandlerBehaviour(),
        'ScrollToBehaviour': new ScrollToBehaviour(),
        'DeckPlanBehaviour': new DeckPlanBehaviour(),
        'TabsBehaviour': new TabsBehaviour(),
        'HideShowBehaviour': new HideShowBehaviour(),
        'BackgroundImageBehaviour': new BackgroundImageBehaviour(),
        'MobileMenuBehaviour': new MobileMenuBehavior(),
        'ShortlistFieldBehaviour': new ShortlistFieldBehavior(),
        'EqualizeBehaviour': new EqualizeBehavior(),
        'PlaceHolderSetterBehaviour': new PlaceHolderSetterBehaviour(),
        'ToggleClassBehaviour': new ToggleClassBehavior(),
        'AccordionBehaviour': new AccordionBehaviour(),
        'LocalstorageFieldPopulationBehaviour': new LocalstorageFieldPopulationBehaviour(),
        'ReadMoreBehaviour': new ReadMoreBehaviour(),
        'ChoiceOtherBehaviour': new ChoiceOtherBehaviour(),
        'MyRolTabBehaviour': new MyRolTabsBehaviour(),
        'TogglePasswordBehavior': new TogglePasswordBehavior(),
        'PreferencesUpdateBehaviour': new PreferencesUpdateBehaviour(),
        'CountdownBehaviour': new CountdownBehavior(),
        'DataLayerBehaviour': new DatalayerBehaviour(),
        'SelectLinkBehaviour': new SelectLinkBehaviour(),
        'CarouselBehaviour': new CarouselBehaviour(),
        'BlockEventBehaviour': new BlockEventBehaviour(),
        'StickyNavBehaviour': new StickyNavBehaviour(),
        'HashBehaviour': new HashBehaviour(),
        'AcousticSignalBehaviour': new AcousticSignalBehaviour(),
        'preventDoubleSubmission': new PreventDoubleSubmitBehaviour(),
    };
config.components = {
        'youtube-video': YoutubeVideo,
        'count-down': CountDown,
        'gallery': Gallery,
        'solo-toggle': SoloToggle,
        'shortlist-count': ShortlistCount,
        'shortlist-button': ShortlistButton,
        'shortlist-show': ShortlistShow,
        'shortlist-clear': ShortlistClear,
        'search': SearchTemplateFull,
        'search-results': SearchTemplateResults,
        'embedded-gallery': EmbeddedGallery,
        'cruise-driver': CruiseDriver,
        "address-lookup": AddressLookup,
    };

// console.log('default.js@83: starting application...');
new Application(config);
